export default __webpack_public_path__ + "static/media/close.c765a5df.svg";